<template>
  <v-menu
    :close-on-content-click="false"
    left
    offset-x
    nudge-left="10"
    v-model="show"
    :close-on-click="false"
    max-height="80%"
    ref="excerptCard"
    content-class="resourceExcerptsPopover"
  >
    <template v-slot:activator="{ on }">
      <v-list-item @click="show = !show" :ripple="false" :class="{ 'v-list-item--active': show }">
        <v-list-item-icon>
          <v-badge :content="excerpts.length" :value="excerpts.length" color="grey" bottom overlap>
            <v-icon>receipt</v-icon>
          </v-badge>
        </v-list-item-icon>
      </v-list-item>
    </template>

    <v-card width="450px">
      <v-btn
        style="position: absolute; top: 3px; right: 3px;"
        elevation="0"
        fab
        x-small
        @click="show = false"
        ><v-icon>close</v-icon></v-btn
      >
      <v-card-title>Excerpts</v-card-title>
      <v-card-text class="pa-0">
        <excerpt-list
          ref="excerptList"
          :resource="resource"
          :userCanEdit="userCanEdit"
          @scrollTo="$emit('scrollTo', $event)"
        >
          <template v-slot:default="slotProps">
            <v-btn
              v-if="userCanEdit && slotProps.selected"
              @click.stop="deleteExcerpt(slotProps.excerpt.id)"
              text
              small
              class="float-right"
              ><v-icon small>close</v-icon> Delete Excerpt</v-btn
            >
          </template>
        </excerpt-list>
        <!-- <v-list>
          <v-list-item
            v-for="excerpt in excerpts"
            :key="excerpt.id"
            :ref="excerpt.id"
            @click="selectExcerpt(excerpt.id)"
            class="px-0"
          >
            <resource-card
              :flat="true"
              :disableHoverShadow="true"
              color="transparent"
              class="pa-4"
              :blockData="{ excerpts: [excerpt], resource: resource }"
              blockType="excerpt"
              style="width: 100%;"
            >
              <template v-slot:after>
                <v-btn
                  v-if="userCanEdit && selectedExcerpt == excerpt.id"
                  @click.stop="deleteExcerpt(excerpt.id)"
                  text
                  small
                  class="float-right"
                  ><v-icon small>close</v-icon> Delete Excerpt</v-btn
                >
              </template>
            </resource-card>
          </v-list-item>
        </v-list> -->
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapActions } from 'vuex';
import ResourceCard from '@/components/Resources/ResourceCard';
import ExcerptList from './ExcerptList';

export default {
  props: ['resource', 'value', 'userCanEdit'],
  components: { ResourceCard, ExcerptList },
  data() {
    return {
      selectedExcerpt: null
    };
  },
  computed: {
    show: {
      get() {
        return this.value == 'excerpts';
      },
      set(v) {
        const val = v ? 'excerpts' : v;
        this.$emit('input', val);
      }
    },
    excerpts() {
      let result;
      try {
        const resourceType = this.resource.resourceData.type;
        if (resourceType == 'webpage' || resourceType == 'pdf') {
          //  TRYING TO SORT FIRST BY POSITION, THEN BY DATE IF NO POSITION
          let positionExcerpts = [];
          let dateExcerpts = [];
          const types = ['textExcerpt', 'imageExcerpt'];
          Object.values(this.resource.noteBlocks).forEach(n => {
            if (n.toDelete || n.type != 'widget' || !types.includes(n.content.widgetType)) {
              return;
            } else {
              if (
                n.content.widgetData.order ||
                (n.content.widgetData.positions && n.content.widgetData.positions[0])
              ) {
                positionExcerpts.push(n);
              } else {
                dateExcerpts.push(n);
              }
            }
          });
          console.log(positionExcerpts, dateExcerpts);
          positionExcerpts = positionExcerpts.sort((a, b) => {
            if (resourceType == 'webpage') {
              return a.content.widgetData.order < b.content.widgetData.order ? -1 : 1;
            } else if (resourceType == 'pdf') {
              return a.content.widgetData.pages[0] + a.content.widgetData.positions[0].y >
                b.content.widgetData.pages[0] + b.content.widgetData.positions[0].y
                ? 1
                : -1;
            }
          });
          dateExcerpts = dateExcerpts.sort((a, b) => {
            const aDate =
              typeof a.createdOn.toDate == 'function' ? a.createdOn.toDate() : a.createdOn;
            const bDate =
              typeof b.createdOn.toDate == 'function' ? b.createdOn.toDate() : b.createdOn;
            return aDate < bDate ? -1 : 1;
          });

          //  Now merge the date excerpts into the position excerpts by date
          let excerpts = [];
          positionExcerpts.forEach(e => {
            //  Do this because when it's first added it's not a datetime object

            const dateExcerpt = dateExcerpts[0];
            if (!dateExcerpt) {
              excerpts.push(e);
              return;
            }
            const dateExDate =
              typeof dateExcerpt.createdOn.toDate == 'function'
                ? dateExcerpt.createdOn.toDate()
                : e.createdOn;
            const exDate =
              typeof e.createdOn.toDate == 'function' ? e.createdOn.toDate() : e.createdOn;
            if (exDate > dateExDate) {
              // we shoudl insert the dateEx before the excerpt
              excerpts.push(dateExcerpt);
              excerpts.push(e);
              //  and remove that excpert from date excerpts
              dateExcerpts = dateExcerpts.slice(1);
            } else {
              excerpts.push(e);
            }
          });
          //  check if there are any left of date excerpts;
          if (dateExcerpts.length) {
            excerpts = excerpts.concat(dateExcerpts);
          }
          result = excerpts;
        } else {
          return [];
        }
        // else if (resourceType == 'pdf') {
        //   result = Object.values(this.resource.noteBlocks)
        //     .filter(e => !e.toDelete)
        //     .sort((a, b) => {
        //       if (a.content.widgetData.positions) {
        //         return a.content.widgetData.pages[0] + a.content.widgetData.positions[0].y >
        //           b.content.widgetData.pages[0] + b.content.widgetData.positions[0].y
        //           ? 1
        //           : -1;
        //       } else {
        //         const aDate =
        //           typeof a.createdOn.toDate == 'function' ? a.createdOn.toDate() : a.createdOn;
        //         const bDate =
        //           typeof b.createdOn.toDate == 'function' ? b.createdOn.toDate() : b.createdOn;
        //         return aDate < bDate ? -1 : 1;
        //       }
        //     });
        // }
      } catch (e) {
        console.log(e);
        result = [];
      }
      return result;
    }
  },
  methods: {
    ...mapActions('resources', ['deleteResourceNoteBlock']),
    selectExcerpt(id) {
      this.$emit('scrollTo', id);

      if (this.selectedExcerpt == id) {
        this.selectedExcerpt = null;
      } else {
        this.selectedExcerpt = id;
      }
    },
    deleteExcerpt(id) {
      this.deleteResourceNoteBlock({ noteBlockId: id, resourceId: this.resource.id });
      this.$emit('removedExcerpt', id);
    },
    scrollTo(id) {
      //console.log(this.$refs[id][0]);
      this.$refs.excerptList.scrollTo(id);
      // this.selectedExcerpt = id;
      // this.$nextTick(() => {
      //   setTimeout(() => {
      //     this.$vuetify.goTo(this.$refs[id][0].$el, { container: '.resourceExcerptsPopover' });
      //   }, 100);
      // });
    }
  }
};
</script>

<style></style>
